import Vue from "vue";
import Router from "vue-router";
import Cookies from "js-cookie";
Vue.use(Router);

const router = new Router({
  mode: "history",
  fallback: false,
  routes: [
    {
      path: "/",
      name: "Home",
      component: () => import("@/views/pages/Home/index.vue")
    },
    {
      path: "/eguarantee",
      name: "HelloWorld",
      component: () => import("@/views/pages/index.vue")
    },
    {
      path: "/details",
      name: "details",
      component: () => import("@/views/pages/guarantee-detail/index.vue")
    },
    {
      path: "/FirstBak",
      name: "FirstBak",
      component: () => import("@/views/pages/FirstBak/index.vue")
    }
  ]
});

// 在导航守卫中监听浏览器关闭事件
router.beforeEach((to, from, next) => {
  if (
    to.name !== "logout" &&
    !window.performance.getEntriesByType("navigation")[0].type === "reload"
  ) {
    const shouldClearCookies = localStorage.getItem("clearCookiesOnUnload");
    if (shouldClearCookies) {
      // 清除cookies的代码
      // 例如：Cookies.remove('name');
      Cookies.remove("SESSION");
    }
  }
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js